<template src="./template.html"/>

<script>
    import Vue from 'vue';
    import axios from 'axios';
    import { store } from "../../store/store";

    export default {
        name: "Dashboard",
        data() {
            return {
                nShopsToValidate: null,
                error: null,
                isShopValidated: false
            }
        },
        mounted() {
            if (store.getters.accountTypeId === Vue.Account.ADMIN ||
                store.getters.accountTypeId === Vue.Account.MUNICIPAL) {

                axios({
                    method: "GET",
                    "url": "/store/admin/count",
                    headers: {
                        Authorization: 'Bearer ' + store.getters.token
                    }
                }).then((result) => {
                    this.nShopsToValidate = result.data.value;
                }).catch((error) => {
                    this.error = error.data.error;
                    this.$bvModal.show('error-modal');
                });
            } else {
                /*
                 * True -> Store valdiated
                 * False -> Store not validated
                 */
                axios({
                    method: "GET",
                    "url": "/store/admin/info",
                    headers: {
                        Authorization: 'Bearer ' + store.getters.token
                    }
                }).then((response) => {
                    this.isShopValidated = response.data.validated;
                }).catch((error) => {
                    this.error = error.data.error;
                    this.$bvModal.show('error-modal');
                })
            }
        }
    }
</script>

<style scoped src="./dashboard.css" />
